// src/components/views/RequestsView.jsx
import Requests from "../Requests";
import { useRequestsDb } from "../../hooks/useDb";

/**
 * Вьюха раздела «Запросы и заявки».
 *
 * initialTab - какая вкладка открыта при монтировании. Пробрасывается
 * из MainLayout: клик по уведомлению о заявке на согласование
 * открывает вкладку 'assignments'; о регистрации - 'reg'; о
 * делегировании - 'rd'; о часах - 'hours'. При обычном входе в раздел
 * через боковое меню MainLayout передаёт 'hours'.
 *
 * Requests хранит активную вкладку в useState(initialTab) - проп
 * читается один раз при монтировании. Чтобы смена initialTab
 * действительно переключала вкладку, MainLayout ставит key={initialTab}:
 * изменение key вызывает пере-монтирование с чистым состоянием.
 *
 * useRequestsDb даёт весь нужный срез: changeRequests, vacations,
 * roleDelegations, regRequests, tasks, projects, employees,
 * departments, assignmentApprovals.
 */
export function RequestsView({ ur, initialTab = "hours" }) {
  const db = useRequestsDb();
  return <Requests db={db} ur={ur} initialTab={initialTab} />;
}
